module.exports = __webpack_public_path__ + "static/img/card-empleo.0277c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-empleo.jpg
// module id = Bf2C
// module chunks = 47